import { listingUtils_getResourceIdAndSlug } from 'app/shared/utils/listingUtils';

type QueryParams = Record<string, string | undefined>;

type SrpProps = {
  pathname: string;
  query: QueryParams;
  isHamburgerMenuOpen: boolean;
};

export type NavigationAction =
  | { type: 'areaResourceIdChanged'; pathname: string; query: QueryParams }
  | { type: 'hamburgerSlugSwitch'; pathname: string; query: QueryParams }
  | { type: 'searchSlugChanged'; pathname: string; query: QueryParams }
  | { type: 'pageChanged'; query: QueryParams }
  | { type: 'mapCoordsChanged'; query: QueryParams }
  | { type: 'none' };

export function getNavigationAction(prevProps: SrpProps, currentProps: SrpProps): NavigationAction {
  const { pathname, query, isHamburgerMenuOpen } = currentProps;
  const hasPageChanged = prevProps.pathname === pathname && prevProps.query.page !== query.page;
  const { resourceId: prevResourceId, slug: prevSlug } = listingUtils_getResourceIdAndSlug(prevProps.pathname);
  const { resourceId: currResourceId, slug: currSlug } = listingUtils_getResourceIdAndSlug(pathname);
  const hasAreaResourceIdChanged = prevResourceId !== currResourceId;
  const hasSearchSlugChanged = prevSlug !== currSlug;
  const wasHamMenuJustActive = prevProps.isHamburgerMenuOpen !== isHamburgerMenuOpen;
  const hasUserSwitchedRentalsViaHamburger = wasHamMenuJustActive && hasSearchSlugChanged;

  const hasMapCoordsChanged =
    prevProps.query &&
    (prevProps.query.lat !== query.lat ||
      prevProps.query.lon !== query.lon ||
      prevProps.query.z !== query.z ||
      prevProps.query.border !== query.border);

  if (hasAreaResourceIdChanged) {
    return { type: 'areaResourceIdChanged', pathname, query };
  }

  if (hasUserSwitchedRentalsViaHamburger) {
    return { type: 'hamburgerSlugSwitch', pathname, query };
  }

  if (hasSearchSlugChanged) {
    return { type: 'searchSlugChanged', pathname, query };
  }

  if (hasPageChanged) {
    return { type: 'pageChanged', query };
  }

  if (hasMapCoordsChanged) {
    return { type: 'mapCoordsChanged', query };
  }

  return { type: 'none' };
}
